import { NgModule } from '@angular/core';
import { TableComponent } from './table.component';
import { EventsModule, ToolModule } from '@circe/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { BadgeModule } from '@circe/badge';
import { FormsModule } from '@angular/forms';
import { FormBehaviorModule } from '@circe/form-behavior';
import { TableActionsModule } from './table-actions/table-actions.module';
import { TableService } from './table.service';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SpinnerModule } from '@circe/spinner';
import { TooltipModule } from '@circe/tooltip';
import { SelectModule } from '@circe/select';

@NgModule({
  declarations: [TableComponent],
  imports: [
    CommonModule,
    ScrollingModule,
    FormsModule,
    TableActionsModule,
    FormBehaviorModule,
    TooltipModule,
    SelectModule,
    BadgeModule,
    SpinnerModule,
    EventsModule.forChild(),
    ToolModule.forChild()
  ],
  providers: [TableService],
  exports: [TableComponent]
})
export class TableModule { }
